































































































































































































































import mixin from './mixin'

export default mixin.extend({
  name: 'TableDatalogEditor',
  components: {},
  data() {
    return {
      tagUid: '',
      forms: [
        { title: 'Value style', name: 'value', attribute: 'valueStyle' },
        { title: 'Label style', name: 'label', attribute: 'labelStyle' },
        { title: 'Unit style', name: 'unit', attribute: 'unitStyle' },
      ],
    }
  },
})
